// Actions Type
export const SET_TOP_SELLERS = 'set_top_sellers';
export const SET_ALL_CUSTOMERS = 'set_all_customers';
export const SET_ALL_CATEGORY = 'set_all_category';
export const SET_ALL_SUBCATEGORY = 'set_all_subcategory';
export const SET_ALL_PRODUCTS = 'set_all_products';
export const SET_SELECTED_PRODUCT = 'set_selected_product';
export const SET_SELECTED_CATEGORY = 'set_selected_category';
export const ADD_TO_CART = 'add_to_cart';
export const SET_UPLOAD_URL = 'set_upload_url'

// Models
export interface TopProductSellers {
    _id: string;
    name: string;
    email: string;
    isAdmin: boolean;
    isSeller: boolean;
    seller: any;
    createdAt: string;
    updatedAt: string;
}

// Action Types
export type ProductTopSellerAction = {
    type: typeof SET_TOP_SELLERS;
    payload: Array<TopProductSellers> | null
}

export type AllCustomersAction = {
    type: typeof SET_ALL_CUSTOMERS;
    payload: any
}

export type ProductsAction = {
    type: typeof SET_ALL_PRODUCTS;
    payload: Array<any> | null
}

export type SelectedProductAction = {
    type: typeof SET_SELECTED_PRODUCT;
    payload: any | null
}

export type SelectedCategoryAction = {
    type: typeof SET_SELECTED_CATEGORY;
    payload: { category: string, subcategory: string } | null
}

export type UploadUrlAction = {
    type: typeof SET_UPLOAD_URL;
    payload: string | null
}

export type ProductActionsType = 
    ProductTopSellerAction |
    AllCustomersAction|
    ProductsAction|
    SelectedProductAction|
    SelectedCategoryAction|
    UploadUrlAction